import { useEffect, useReducer, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEditBookMutation } from "../../features/api/apiSlice";
// import { useEditVideoMutation } from "../../features/api/apiSlice";
import Error from "../ui/Error";
import Success from "../ui/Success";

export default function EditForm({ book }) {
    const [editBook, { isLoading, isError, isSuccess }] = useEditBookMutation();
    const navigate = useNavigate();

    const initialData = {
        name: book?.name || '',
        author: book?.author || '',
        thumbnail: book?.thumbnail || '',
        price: book?.price || '',
        rating: book?.rating || '',
        featured: book?.featured || false
    };

    const [data, setData] = useReducer((prev, next) => {
        return { ...prev, ...next };
    }, initialData)



    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateData(data)) {
            editBook({ id:book.id, data })
        }
    }

    useEffect(() => {
        if (isSuccess) {
            setData({ ...initialData })
            navigate("/")
        }

    }, [isSuccess, navigate]);

    const validateData = (bookObj) => {
        return bookObj && Object.entries(bookObj).length &&
            bookObj.name && bookObj.author && bookObj.rating && bookObj.thumbnail && bookObj.price
    }


    return (
        <form className="book-form" onSubmit={handleSubmit}>
            <div className="space-y-2">
                <label htmlFor="lws-bookName">Book Name</label>
                <input value={data?.name} onChange={(e) => setData({ name: e.target.value })} required className="text-input" type="text" id="lws-bookName" name="name" />
            </div>

            <div className="space-y-2">
                <label htmlFor="lws-author">Author</label>
                <input value={data?.author} onChange={(e) => setData({ author: e.target.value })} required className="text-input" type="text" id="lws-author" name="author" />
            </div>

            <div className="space-y-2">
                <label htmlFor="lws-thumbnail">Image Url</label>
                <input value={data?.thumbnail} onChange={(e) => setData({ thumbnail: e.target.value })} required className="text-input" type="text" id="lws-thumbnail" name="thumbnail" />
            </div>

            <div className="grid grid-cols-2 gap-8 pb-4">
                <div className="space-y-2">
                    <label htmlFor="lws-price">Price</label>
                    <input value={data?.price} onChange={(e) => setData({ price: e.target.value })} required className="text-input" type="number" id="lws-price" name="price" />
                </div>

                <div className="space-y-2">
                    <label htmlFor="lws-rating">Rating</label>
                    <input value={data?.rating} onChange={(e) => setData({ rating: e.target.value })} required className="text-input" type="number" id="lws-rating" name="rating" min="1"
                        max="5" />
                </div>
            </div>

            <div className="flex items-center">
                <input checked={data?.featured} value={data?.featured} onChange={(e) => setData({ featured: e.target.checked })} id="lws-featured" type="checkbox" name="featured" className="w-4 h-4" />
                <label htmlFor="lws-featured" className="ml-2 text-sm"> This is a featured book </label>
            </div>

            <button type="submit" className="submit" id="lws-submit">Edit Book</button>
        </form>
    );
}
